import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { UpdateCwsIconFilePeriodVo } from '../vo/update-cws-icon-file-period.model'

/**
 * CWSアイコンファイル適用期間更新
 *
 * @export
 * @class UpdateCwsIconFilePeriod
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class UpdateCwsIconFilePeriod extends PlessJsonResponderSub<any> {
  private vo: UpdateCwsIconFilePeriodVo;
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof UpdateCwsIconFilePeriod
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        IconCode: this.vo.iconCode,
        IconCodeBranch: this.vo.iconCodeBranch,
        StartOrderCode: this.vo.startOrderCode,
        EndOrderCode: this.vo.endOrderCode
      }
    });
  }

  /**
   * API呼び出し
   *
   * @memberof UpdateCwsIconFilePeriod
   */
  execute(vo: UpdateCwsIconFilePeriodVo, successFunc: Function = null): void {
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('updateCwsIconFilePeriod', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof UpdateCwsIconFilePeriod
   */
  success(data: any): void {
    if (data !== null) {
      this.successFunc(data);
    }
  }
}
